// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y5sC","textarea":"styles_textarea__12Z9w"};